import {Component, ElementRef, OnInit, ViewChild,NgModule} from '@angular/core';
import {QuestionInput} from '../question-input';
import {ChoiceQuestion} from '../../model/questions/choise-question';
import {QuestionInfo} from '../../model/question.model';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss']
})
export class SelectComponent extends QuestionInput implements OnInit {

    @ViewChild('selectElement', {static: true})
    selectElement:any;
    selectOpen = false;

    selectClick(){
        this.selectElement.open();
    }


    constructor() {
        super();
    }

    ngOnInit() {

        if (this.question.answer && !!this.question.answerTitle) {
            this.questionAnswered.emit(true);
        }

        this.questionAnswered.emit(true);
    }

    getBoxShadow() {
        // if (this.question.question.page) {
        //     return 'box-shadow';
        // }
        //
        // return '';
    }

    valueSelected(event) {
        this.questionAnswered.emit(!!event);
        //this.questionAnswered.emit(!!event.target.value);
    }

    get answer(): any {
        if(this.selectElement.value != undefined){
            return this.selectElement.value;
        }
        //console.log(this.selectElement.value);
        return "";

        //return this.selectElement.value;
        //return this.selectElement.nativeElement.value;
    }
    openedChange(opened: boolean) {
        if (opened) {
            this.selectOpen = true;
        } else {
            this.selectOpen = false;
        }
    }
}
